import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { map, Observable, throwError, finalize } from "rxjs";
import { HttpErrorResponse } from "@angular/common/http";
import { CoreService } from "./core.service";
import { OrderProductItem } from "../models/orderproduct.model";
import { BasketItem } from "../models/basketitem.model";
import { OrderRequest } from "../models/orderrequest.model";
import { mix_match_response } from "../models/baske.model";
import { API } from "./paymentapiroutes";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class OrderService {
  products: OrderProductItem[] = [];
  product: OrderProductItem;
  SpecialInstructions: string;
  orderRequest: OrderRequest;
  private isPlacingOrder = false;
  constructor(
    private apiService: ApiService,
    private coreService: CoreService,
    private http: HttpClient,
  ) {}

  placeOrder(
    basketItems: BasketItem[],
    ordertype: string,
    SpecialInstructions: string,
    selectedWaiter: number,
    selectedTable: number,
    selectedAssingTable: number,
    selectedRoom: number,
    fulfillmentType: string,
    paymentmethod: string,
    selectedpromocode: number,
    loginenable: number,
    mix_and_match_ids: mix_match_response[],
    AppType: number,
    latitude: number,
    longitude: number,
    email: string,
    phone: string,
    address_id: number,
    isTip: boolean,
    tipAmount: number,
    processingFee: number,
  ): Observable<any> {
    // if (this.isPlacingOrder) {
    //   return throwError(
    //     () => new Error("Order placement is already in progress."),
    //   );
    // }
    const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
    if (this.isPlacingOrder) {
      return throwError(() => ({
        duplicateOrder: true,
        message: "Order placement is already in progress.",
      }));
    }
    // this.isPlacingOrder = true;
    this.coreService.hideShowLoader(true);

    this.products = [];
    basketItems.map((data) => {
      this.product = {
        id: data.Id,
        qtyid: data.qtyId?.includes("_") ? data.qtyId.split("_")[1] : null,
        product_category_id: data.productcatId,
        product_id: data.productId,
        quantity: data.quantity,
        variant: data.selectedVariantid,
        product_instruction: data.special_instruction,
        additional_instruction_image: data.special_instruction_image,
      };
      this.products.push(this.product);
    });
    this.orderRequest = {
      order_from: 2,
      retailer_id: CoreService.retailerId,
      products: this.products,
      type: ordertype,
      address_id: address_id,
      device_type: this.coreService.GetOperatingSystem(),
      webapp_payment_option: paymentmethod,
      special_instructions: SpecialInstructions,
      webapp_facility_flag: fulfillmentType,
      assign_order_table_id: selectedAssingTable,
      order_table_id: selectedTable,
      waiter_id: selectedWaiter,
      room_id: selectedRoom,
      promocode_id: selectedpromocode,
      is_login_registration_allowed: address_id ? 1 : loginenable,
      mix_and_match_ids: mix_and_match_ids,
      webapp_type: AppType,
      latitude: latitude,
      longitude: longitude,
      guest_access_email: email,
      guest_access_phone: phone,
      is_tip: isTip,
      tip_price: tipAmount,
      processing_fees: processingFee,
      multioutlet_id:
        CoreService.MultiOutletId == 0 ? null : CoreService.MultiOutletId,
    };
    if (currentUser?.guest_access_allowed) {
      if (currentUser?.email) {
        this.orderRequest.guest_access_email = currentUser.email;
      }
      if (currentUser?.phoneNumber) {
        this.orderRequest.guest_access_phone = currentUser.phoneNumber;
      }
    }
    return this.apiService.post(API.ORDER_PLACE, this.orderRequest).pipe(
      finalize(() => {
        this.isPlacingOrder = false;
        this.coreService.hideShowLoader(false);
      }),
    );
  }

  finalOrder(retailerId, orderId, status): Observable<any> {
    return this.apiService.get(
      API.ORDER_STATUS_UPDATE +
        `${retailerId}/order/${orderId}/success/${status}`,
    );
  }

  GetOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor;
    let DeviceType = "";
    //Check mobile device is Android
    if (/android/i.test(userAgent)) {
      DeviceType = "a";
    }

    //Check mobile device is IOS
    else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      DeviceType = "i";
    }

    //Check device os is Windows (For Laptop and PC)
    else if (navigator.appVersion.indexOf("Win") != -1) {
      DeviceType = "a";
    }

    //Check device os is MAC (For Laptop and PC)
    else if (navigator.appVersion.indexOf("Mac") != -1) {
      DeviceType = "i";
    }
    return DeviceType;
  }

  getDeliveryfee(param): Observable<any> {
    return this.apiService.get(
      API.DELIVERYPRODUCT + `?retailer_id=${CoreService.retailerId}&${param}`,
    );
  }

  getOrderHistory(
    page,
    page_size,
    retailerid,
    sort_column,
    sort_type,
  ): Observable<any> {
    let url = API.USERORDERS;

    // Example of adding a conditionally optional parameter
    if (page_size && page_size !== "") {
      url += `?page_size=${page_size}`;
    }

    if (page && page !== "") {
      url += `&page=${page}`;
    }

    if (retailerid && retailerid !== "" && retailerid != "0") {
      url += `&retailer_id=${retailerid}`;
    }

    if (sort_column && sort_column !== "") {
      url += `&sort_column=${sort_column}`;
    }

    if (sort_type && sort_type !== "") {
      url += `&sort_type=${sort_type}`;
    }

    return this.apiService.get(url).pipe(
      map((resp) => {
        if (resp.Error) {
          throwError(resp.Error);
        } else {
          return resp.data;
        }
      }),
    );
  }

  getOrderDetail(orderId): Observable<any> {
    return this.apiService.get(API.GETORDERDETAIL + `/${orderId}`).pipe(
      map((resp) => {
        if (resp.Error) {
          throwError(resp.Error);
        } else {
          return resp.data;
        }
      }),
    );
  }
  getOutletDetail(): Observable<{ [key: string]: string }> {
    return this.apiService.get(API.GETUSEROUTLET).pipe(
      map((resp) => {
        if (resp.Error) {
          throwError(resp.Error);
        } else {
          return resp;
        }
      }),
    );
  }

  getReferralOutletDetail(): Observable<{ [key: string]: string }> {
    return this.apiService.get(API.GETREFERRALUSEROUTLET).pipe(
      map((resp) => {
        if (resp.Error) {
          throwError(resp.Error);
        } else {
          return resp;
        }
      }),
    );
  }

  // uploadInstructionImage(
  //   file: File,
  // ): Observable<{ path: string; url: string }> {
  //   console.log("uploadInstructionImage - file details:", {
  //     name: file?.name,
  //     size: file?.size,
  //     type: file?.type,
  //     lastModified: file?.lastModified,
  //     isFile: file instanceof File,
  //   });

  //   if (!file) {
  //     console.error("Invalid file object: file is null");
  //     return throwError(() => new Error("Invalid file: file is null"));
  //   }

  //   if (file.size === 0) {
  //     console.error("Invalid file object: file size is 0");
  //     return throwError(() => new Error("Invalid file: file size is 0"));
  //   }

  //   const formData = new FormData();
  //   formData.append("image", file, file.name);
  //   console.log("FormData created, file appended:", {
  //     fileName: file.name,
  //     fileSize: file.size,
  //     fileType: file.type,
  //   });
  //   return this.apiService.formDataPost(API.UPLOAD_INSTRUCTION_IMAGE, formData);
  // }

  uploadInstructionImage(
    file: File,
  ): Observable<{ path: string; url: string }> {
    console.log("uploadInstructionImage - HttpClient version called");
    console.log("uploadInstructionImage - file details:", {
      name: file?.name,
      size: file?.size,
      type: file?.type,
      lastModified: file?.lastModified,
      isFile: file instanceof File,
    });

    if (!file) {
      return throwError(() => new Error("Invalid file: file is null"));
    }

    if (file.size === 0) {
      return throwError(() => new Error("Invalid file: file size is 0"));
    }

    return new Observable<{ path: string; url: string }>((observer) => {
      const reader = new FileReader();

      reader.onload = () => {
        const arrayBuffer = reader.result as ArrayBuffer;
        const blob = new Blob([arrayBuffer], { type: file.type });

        const formData = new FormData();
        formData.append("image", blob, file.name);

        console.log("FormData created with blob:", file.name);
        console.log("FormData has 'image' key:", formData.has("image"));
        console.log("Blob size:", blob.size);
        console.log("ArrayBuffer size:", arrayBuffer.byteLength);

        this.apiService
          .formDataPost(API.UPLOAD_INSTRUCTION_IMAGE, formData)
          .subscribe({
            next: (response) => {
              observer.next(response);
              observer.complete();
            },
            error: (error) => {
              observer.error(error);
            },
          });
      };

      reader.onerror = () => {
        observer.error(new Error("Failed to read file"));
      };

      reader.readAsArrayBuffer(file);
    });
  }
}
